import {
  InputWrapper,
  SaveCredentialsFormField,
  SecondaryBody2,
  ServerKeyContent,
  StyledClickToCopy,
} from 'modules/webPush/WebPushV2/components/Modals/components/styles';

export const SAVE_EXISTING_FIREBASE_CREDENTIALS_ID = 'save-existing-firebase-credentials';

const LabelText = () => (
  <>
    Save existing credentials
    <SecondaryBody2>{'(optional)'}</SecondaryBody2>
  </>
);

type Props = { fcmSenderId: string; fcmServerKey: string };

export const SaveExistingFirebaseCredentials = ({ fcmSenderId, fcmServerKey, ...props }: Props) => {
  return (
    <SaveCredentialsFormField
      descriptionText="If you upload the incorrect JSON file, you can re-use your existing Server key and Sender ID to avoid down time."
      labelText={<LabelText />}
      {...props}
    >
      <InputWrapper>
        <StyledClickToCopy
          data-test={`${SAVE_EXISTING_FIREBASE_CREDENTIALS_ID}-server-key-copy-button`}
          content={fcmServerKey}
          prependContent="Server key"
        >
          <ServerKeyContent>{fcmServerKey}</ServerKeyContent>
        </StyledClickToCopy>
        <StyledClickToCopy
          data-test={`${SAVE_EXISTING_FIREBASE_CREDENTIALS_ID}-sender-id-copy-button`}
          content={fcmSenderId}
          prependContent="Sender ID"
        >
          {fcmSenderId}
        </StyledClickToCopy>
      </InputWrapper>
    </SaveCredentialsFormField>
  );
};
